module.exports = __webpack_public_path__ + "static/media/user-thumbnail.1c6bc31f.png";